export default "__VITE_ASSET__ce7869b7__"